import { scrollGutterPluginKey } from '../pm-plugins/scroll-gutter/plugin-key';
export var setKeyboardHeight = function setKeyboardHeight(keyboardHeight) {
  return function (state, dispatch) {
    var tr = state.tr;
    tr.setMeta(scrollGutterPluginKey, {
      keyboardHeight: keyboardHeight
    });
    if (dispatch) {
      dispatch(tr);
    }
    return true;
  };
};